import { Link } from "react-router-dom";
const { default: styled } = require("styled-components");

export const Container = styled.div`
  max-width: 100%;
  min-height: 250px;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  padding-left:0px;
  background-color:white;
  padding: 0 15px;
  table{
   overflow:auto;
  }
`;

export const Heading = styled.div`
  float: left;
  margin: 20px 20px 20px 25px;
  color: #4678ED;
  font-size: 18px;
  font-weight:600;
  font-family: Montserrat,"SemiBold", "Open Sans", Helvetica, Arial, sans-serif;
`;
export const Refresh = styled(Link)`
  float: right;
  margin: 20px;
  font-size: 12px !important;
  text-decoration: none;
  color: grey;
  font-weight:500;
`;


export const ADImage = styled.img`
width:786px;
height:90px;
@media (max-width:1066px){
  width:90%;
}
`
export const Table = styled.table`
  width: 100%;
  padding: 0px 20px 0px 25px;
  text-align: center;
  border: none;
  overflow:auto;
  
  th {
    padding: 0px 20px 0px 35px;
    height: 50px;
    font-weight: 600;
    text-align: left;
    border: none;
    font-size:14px;
    min-width:100px;
    color:#58595B;
    font-weight:600;
    font-family: "Montserrat SemiBold", "Open Sans", Helvetica, Arial, sans-serif;
  }
  td {
    border: none;
    padding: 15px 20px 15px 35px;
    font-weight: normal;
    font-size:14.13px;
    text-align: left;
    min-width:100px;
    color:#58595B;
    font-weight:400;
    font-family: "Montserrat Medium", "Open Sans", Helvetica, Arial, sans-serif;
  }

  tr:nth-child(even){
    background-color: #F9F9F9;
  }
`;

export const Diagnosisdiv = styled.div`
  display:grid;
  grid-template-columns: 100%;
  width:100%;
  &.noCreative{
    grid-template-columns: 100% ;

  }
`
export const DiagnosisTable = styled.div`

`